import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { genreFilters, relatedGenres } from "@/mocks/movieData";

export default function RelatedSection() {
  const [filter, setFilter] = useState("全部");

  const list = useMemo(
    () => (filter === "全部" ? relatedGenres : relatedGenres.filter((item) => item.category === filter)),
    [filter]
  );

  return (
    <section id="related" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="More Like This"
            title="同类题材推荐"
            desc="如果你喜欢这部剧的题材方向，可以按类别浏览其它相近类型，快速找到下一步想看的内容方向。"
          />
          <div className="flex flex-wrap gap-2">
            {genreFilters.map((cat) => (
              <button
                key={cat}
                type="button"
                aria-pressed={filter === cat}
                onClick={() => setFilter(cat)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  filter === cat
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 border border-background-200 hover:border-primary-300"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {list.map((item) => (
            <article
              key={item.title}
              className="rounded-xl bg-background-100 border border-background-200 p-5 hover:border-accent-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-label">
                  {item.category}
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-500 text-lg">
                  <i className="ri-film-line" />
                </span>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}